import { useCallback, useMemo } from 'react';

import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import { PaymentType, useJobContext } from 'pages/Job/context';

import { TITLES } from '../constants';

export const BACS_FINANCE_OPTION: FinanceRate = {
  name: 'bank',
  fee: 0,
  charge: 0,
  enabled: true,
  finance_types: ['primary'],
  provider: 'demo',
};

export interface BasePaymentSelectCardHook {
  buttonClassName: string;
  buttonId: string;
  onClick: () => void;
  indicatorClassName: string;
  title: string;
  type: PaymentType;
}

export default function useBasePaymentSelectCard(
  type: PaymentType,
): BasePaymentSelectCardHook {
  const { paymentType, setPaymentType } = useJobContext();

  const active = useMemo(() => paymentType === type, [paymentType, type]);

  const buttonClassName = useMemo(
    () =>
      [
        'p-4 md:p-6 border-2 rounded-xl transition-all flex flex-col group shadow-lg',
        active
          ? 'bg-purple-50 border-purple-400'
          : 'bg-neutral-000 border-neutral-300 hover:border-purple-200',
      ].join(' '),
    [active],
  );

  const indicatorClassName = useMemo(
    () =>
      [
        'w-6 h-6 min-w-6 min-h-6 border-2 rounded-full transition-all flex',
        active
          ? 'bg-purple-400 border-purple-400'
          : 'bg-neutral-000 border-neutral-300 group-hover:border-purple-200',
      ].join(' '),
    [active],
  );

  const buttonId = useMemo(() => `payment-type-${type}`, [type]);

  const title = useMemo(() => TITLES[type], [type]);

  const onClick = useCallback(() => {
    setPaymentType(type);
  }, [type, setPaymentType]);

  return {
    buttonClassName,
    buttonId,
    onClick,
    indicatorClassName,
    title,
    type,
  };
}
